
import * as Yup from 'yup';

export type HomeFormValues = {
  address?: string;
  closestWarehouseID?: string;
  unit?: string;
  title?: string;
  slug?: string;
  place_id?: string;
  type?: guesthouse.HomeType;
  beds?: number;
  baths?: number;
  sqft?: number;
  status?: guesthouse.HomeStatus;
  notes?: string;
  install_date?: Date;
  deinstall_date?: Date;
  consult_date?: Date;
  photoshoot_date?: Date;
  zillow_url?: string;
  listing_price?: number;
  case_study?: boolean;
  case_study_title?: string;
  case_study_the_home?: string;
  case_study_listed_by?: string;
  case_study_services_booked?: string;
  case_study_vibe?: string;
  case_study_staging_turnaround?: string;
  case_study_main_cta_text?: string;
  case_study_description?: string;
  case_study_testimonial_text?: string;
  case_study_testimonial_author?: string;
  staging_type?: guesthouse.onboarding.CheckoutOption;
};

export const initialValues: HomeFormValues = {};

const HomeSchema = Yup.object().shape({
  address: Yup.string()
    .nullable(),
  closestWarehouseID: Yup.string()
    .nullable()
    .required('Closest warehouse is required'),
  place_id: Yup.string()
    .nullable()
    .required('Address is required'),
  type: Yup.string()
    .required('Type is required'),
  listing_price: Yup.number()
    .typeError('Listing price must be a valid number')
    .min(0, 'Listing price should be greater than 0'),
  beds: Yup.number()
    .typeError('Number of bedrooms must be a valid number')
    .min(0, 'Number of bedrooms should be greater than 0'),
  baths: Yup.number()
    .typeError('Number of baths must be a valid number')
    .min(0, 'Number of baths should be greater than 0'),
  sqft: Yup.number()
    .typeError('Sqft must be a valid number')
    .min(0, 'Sqft should be greater than 0'),
  notes: Yup.string(),
  zillow_url: Yup.string()
    .nullable()
    .url('Please enter a valid URL, including http:// or https://')
});

export default HomeSchema;
